import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ProblemSolution from '../components/ProblemSolution';
import Services from '../components/Services';
import Process from '../components/Process';
import Benefits from '../components/Benefits';
import Portfolio from '../components/Portfolio';
import About from '../components/About';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <Services />
        <Process />
        <Benefits />
        <Portfolio />
        <About />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
